import $ from 'jquery';

const CLASS = {
    IS_OPEN: 'is-open',
    IS_ACTIVE: 'is-active',
    LEFT_MENU: "js-leftnav",
    FIRST_LVL: "js-mainnav-link"
}

const SELECTOR = {
    BREADCRUMB_CHANNEL_IDS_SELECTOR: "#breadcrumb-channel-ids",
    DATA_CHANNEL_ID_ATTR: "data-channelid",
    FIRST_LVL: ".js-mainnav-link",
    CONTAINER_MENU_DESKTOP: '.js-nav-desktop',
    SECOND_LVL: ".js-secondlvl-link",
    PARENT_SUBLEVEL: '.js-sub-level',
    CONTAINER_SUBLEVEL: '.js-container-sublevel',
    SELECTOR_DROPDOWN : ".js-dropdown",
    SELECTOR_DROPDOWN_CONTENT : ".js-dropdown-content",
    SELECTOR_DROPDOWN_BTN: ".js-dropdown-btn",
    SELECTOR_DROPDOWN_ITEMS: ".js-submenu_elt-in-dropdown",
    TABLET_FIFTH_ELEMENT : ".js-dropdown-item-only-tablet",
    DESKTOP_FIFTH_ELEMENT : ".js-item-only-desktop"
};

var breakPointMobile = 768;
var breakPointTablet = 1024;

export default class NavPanelDesktop {
    constructor() {
        var _self = this;

        _self.$firstLinkActive = null;
        _self.$panel = $(SELECTOR.CONTAINER_MENU_DESKTOP);
        _self.$subLvlContainer = $(SELECTOR.CONTAINER_SUBLEVEL);
		
		// Only hide if doesn't contain a submenu yet (view moves from desktop to mobile and back)
		if (_self.$subLvlContainer.find(SELECTOR.SECOND_LVL).length==0)
			_self.$subLvlContainer.hide();

        // get channel Ids from dom
        _self.currentChannelBreadcrumb = $(SELECTOR.BREADCRUMB_CHANNEL_IDS_SELECTOR).val();

        // get first list of links
        _self.$firstLvlLinks = _self.$panel.children("li");

        // perform anchors context
        _self.$linksWithAnchors = $('*[data-cm="1"]');
        if (_self.$linksWithAnchors.length > 0) {
            _self.generateFriendlyUrlWithAnchors();
        }
    }

    /**
     * Init App
     */
    init() {
        var _self = this;

        _self.bindLinkSecondLevel();
        _self.setActiveLink();
        if (_self.hasDropDown)
            _self.bindEventDropDown();
    }

    /*
       BIND CLICK FOR SECOND LEVEL LINKS
    */
    bindLinkSecondLevel() {
        var _self = this;
        function updateHighlight() {
            if (_self && (typeof _self.$secondLvlLinks !== 'undefined')) {
                //_self.$secondLvlLinks.removeClass(CLASS.IS_ACTIVE);
                _self.setActiveLink();
            }
        }
        window.addEventListener('hashchange', updateHighlight, false);
    }


    /*
       Perform menu
    */
    setActiveLink() {
        var _self = this;

        if (_self.currentChannelBreadcrumb != undefined) {
		    /* Activate highlight to the link for first lvl  */
			_self.$firstLvlLinks.each(function(index, element) {
				var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
				if (currentChannelId !== "" && _self.currentChannelBreadcrumb.indexOf(currentChannelId) >= 0) {
					_self.$firstLinkActive = $(element);
					_self.activateElt(_self.$firstLinkActive);
					
					// Perform 2nd level of first level link
					if (_self.$firstLinkActive.hasClass(CLASS.FIRST_LVL)) //"js-mainnav-link"
						_self.initSecondLvl(_self.$firstLinkActive);
			   }
			});
        }
    }


    /*
        GENERATE URL WITH ANCHOR
    */
    generateFriendlyUrlWithAnchors() {
        var _self = this;
		
        _self.$linksWithAnchors.each(function(){
            var $this = $(this);
            if ($this.data('anchor')) {
                var newHref = $this.attr("href") + $this.data('anchor');
                $this.attr("href", newHref)
            }
        });
    }


    /*
        BIND CLICK FOR DROPDOWN
    */
    bindEventDropDown() {
        var _self = this;

		_self.$dropDownBtn.off("click");
        _self.$dropDownBtn.on("click", function () {
            //_self.$dropDown.toggleClass(CLASS.IS_ACTIVE);
            if (_self.$dropDownBtn.attr("aria-expanded") == "true") {
                _self.$dropDownBtn.attr("aria-expanded","false");
				_self.$dropDown.removeClass(CLASS.IS_ACTIVE);
            } else {
                _self.$dropDownBtn.attr("aria-expanded","true");
				_self.$dropDown.addClass(CLASS.IS_ACTIVE);
            }
        });
    }


    /*
      GET CURRENT CONTEXT OF WINDOWS
    */
    initFormatContext() {
        var _self = this;
        if ((breakPointMobile < $(window).width()) && ($(window).width() <= breakPointTablet)) {
            _self.contextTablet = true;
            _self.contextDesktop = false;
        } else {
            _self.contextTablet = false;
            _self.contextDesktop = true;
        }
    }


    /*
        REMOVE EXTRA ENTRY IN MENU
    */
    removeExtraItem() {
        var _self = this;
        if (_self.contextTablet) {
            var $desktopFifthLi = $(SELECTOR.DESKTOP_FIFTH_ELEMENT);
            if ($desktopFifthLi.length > 0){
                $desktopFifthLi.remove();
            }
        } else if (_self.contextDesktop) {
            var $tabletFifthLi = $(SELECTOR.TABLET_FIFTH_ELEMENT);
            if ($tabletFifthLi.length > 0){
                $tabletFifthLi.remove();
            }
        }
    }


    /**
     * Init Second Lvl
	 * Moves secondlevel menu to subLvlContainer
     */
    initSecondLvl($mainLink) {
        var _self = this;
		
        _self.$secondLvlLinks = $mainLink.find(SELECTOR.SECOND_LVL);
        if (_self.$secondLvlLinks.length > 0) {
            var $secondLvl = _self.$firstLinkActive.find(SELECTOR.PARENT_SUBLEVEL);

			// generate context on left part
            if ($secondLvl.hasClass(CLASS.LEFT_MENU)) {
				_self.performLeftMenu();
			} else {
				_self.activateSecondLvlWithChannelId();
			}
			_self.$subLvlContainer.prepend($secondLvl);
			_self.$subLvlContainer.show();
            _self.initDropDown();
        }
    }

	// Activates 2nd level link if in breadcrumb
    activateSecondLvlWithChannelId() {
        var _self = this;
		
        _self.$secondLvlLinks.each(function(index, element){
            var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
            if ( currentChannelId !== "" && _self.currentChannelBreadcrumb.indexOf(currentChannelId) >= 0)
				_self.activateElt($(element));
        });

        /*  Remove active class in single page context (multi link related to same channel ID)
            TODO : REFACTO FOR THIS SPECIFIC CONTEXT       
        var nbSecondLinkActivated = 0;
        if (nbSecondLinkActivated > 1){
            $listLinks.each(function(index, element){
                _self.deactivateElt($(element));
            });
        } */
    }

    /*
        PRO & ENT MARKET CONTEXT
		- Activates link of current page (first item in breadcrumb),
		- then opens left menu bottom up
    */
    performLeftMenu() {
        var _self = this;
		
        var currentChannelIdsArray = _self.currentChannelBreadcrumb.split(/[\s,]+/);
        var $activeLink = _self.$firstLinkActive.find("li[data-channelid="+currentChannelIdsArray[0]+"]")
        if ($activeLink.length > 0) {
            _self.activateElt($activeLink);
            _self.processLeftParent($activeLink);
        }
		// Si page pas dans le menu, activer qd même lien niv. 2 dont la page est un sousrubrique
		else {
			_self.activateSecondLvlWithChannelId();
		}	

    }

    processLeftParent($currentElement) {
        var _self = this;
        var $parentsLi = $currentElement.parents('.js-leftnav-link');

        if ($parentsLi.length > 0) {
            var $parentLi = $parentsLi.eq(0);
            var $btn = $parentLi.find('.js-menu-left_toggle').eq(0);
			$btn.addClass("is-active is-open");
			$btn.next().stop(true).slideDown();
			$btn.children("svg").removeClass("is-up");
			$btn.children("svg").addClass("is-up");

            _self.processLeftParent($parentLi);
        } else {
            $currentElement.addClass("parent-active");
        }
    }


    /**
     * Init DropDown & clean it if empty
     */
    initDropDown() {
        var _self = this;

        _self.$dropDown = _self.$subLvlContainer.find(SELECTOR.SELECTOR_DROPDOWN);

        if (_self.$dropDown.length > 0) {
            // CHECK IF ITEMS ARE STILL HERE IN DROPDOWN
            _self.$dropDownItems = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_ITEMS);

            if (_self.$dropDownItems.length > 0) {
                _self.$dropDownBtn = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_BTN);
                _self.$dropDownContent = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_CONTENT);
                _self.hasDropDown= true;
            } else {
                _self.$dropDown.remove();
                _self.hasDropDown = false;
            }
        } else {
            _self.hasDropDown = false;
        }
    }



    /*
        GENERIC FUNCTIONS
     */
    deactivateElt($element) { $element.removeClass(CLASS.IS_ACTIVE); }

    activateElt($element) {
        $element.addClass(CLASS.IS_ACTIVE);
		$element.children("a").attr("aria-current", "page");
    }

    /* TODO : CHECK IF DEPRECATED  */
    activeLinkWithAnchor($elements) {
        $elements.each(function(){
            if (window.location.href.indexOf($(this).data('anchor')) !== -1) {
                $(this).parent().addClass(CLASS.IS_ACTIVE);
            }
        });
    }

    /*  DEPRECATED
    performLeftSecondLvl(currentPageId, $listLinksSecondLvl) {
        var _self = this;
        $listLinksSecondLvl.each(function(index, element){
            var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
            if (currentPageId.indexOf(currentChannelId) >= 0) {
                var $currentElement = $(element);
                $currentElement.addClass(CLASS.IS_ACTIVE);
                _self.activateLeftLink($currentElement);
            }
        });
    } */
}


// WEBPACK FOOTER //
// ./src/components/header/lhs/transverse/navPanelDesktop.js